import { useContext } from "react";
import { EntitlementsContext } from "../context/entitlements-context";

export function useEntitlements() {
  const context = useContext(EntitlementsContext);
  if (!context) {
    throw new Error(
      "useEntitlements must be used within an EntitlementsProvider",
    );
  }
  return context;
}
